// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { Link } from 'react-router-dom';
import './Tabs.css';

export interface TabDefinition {
  key: string;
  label: string;
  path: string;
  badge?: number;
  highlightClass?: string;
}

interface TabsProps {
  tabs: TabDefinition[];
  activeTab: string;
  className?: string;
  ariaLabel?: string;
}

function Tabs({ tabs, activeTab, className, ariaLabel }: TabsProps) {
  return (
    <nav className={`underline-tabs${className ? ` ${className}` : ''}`} aria-label={ariaLabel}>
      {tabs.map(tab => {
        const isActive = tab.key === activeTab;
        const classes = [
          'underline-tab',
          isActive ? 'underline-tab-active' : '',
          tab.highlightClass ?? '',
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <Link key={tab.key} to={tab.path} className={classes}>
            {tab.label}
            {tab.badge != null && tab.badge > 0 && (
              <span className="underline-tab-badge">{tab.badge}</span>
            )}
          </Link>
        );
      })}
    </nav>
  );
}

export default Tabs;
